import { render } from "./NavLink.vue?vue&type=template&id=4fa51101&scoped=true"
import script from "./NavLink.vue?vue&type=script&lang=js"
export * from "./NavLink.vue?vue&type=script&lang=js"

import "./NavLink.vue?vue&type=style&index=0&id=4fa51101&lang=scss"
import "./NavLink.vue?vue&type=style&index=1&id=4fa51101&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa51101"]])

export default __exports__